export default __webpack_public_path__ + "static/media/payment-vodafone.472aa9ba.svg";